import React, { useState, useCallback, useEffect } from 'react'
import Sidebar from '../../../components/sidebar/Sidebar'
import Header from '../../../components/headerbar/Header'
import {config} from '../../../config'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useFormik } from 'formik'
import * as yup from 'yup'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import _ from 'lodash'

const EditStore = () => {
  const navigate = useNavigate()
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const { id } = useParams()
  const [details, setDetails] = useState()

  // update store
  const handleStore = (formValues) => {
    const data = {
      mobileNo: formValues?.mobileNo,
      landlineNo: formValues?.landline,
      address: formValues?.address,
      mapLink: formValues?.mapLink,
      city: formValues?.city,
    }
    const url = config.apiurl + `/store/${id}`
    const configdata = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    }
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        toast('Store updated successfully')
        setTimeout(() => {
          navigate('/store')
        }, 2000)
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    axios.put(url, data, configdata).then(onSuccess, onFailure)
  }

  const formik = useFormik({
    initialValues: {
      mobileNo: '',
      landline: '',
      address: '',
      mapLink: '',
      city: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      mobileNo: yup
        .string()
        .required('Mobile number is required')
        .matches(/^[0-9]+$/, 'Only Numbers are allowed')
        .max(10, `Max 10 digits are allowed`)
        .min(10, `Must be exactly 10 numbers`)
        .nullable(),
      landline: yup
        .string()
        .required('landline number is required')
        .matches(/^[0-9]+$/, 'Only Numbers are allowed')
        .max(11, `Max 11 digits are allowed`)
        .min(11, `Must be exactly 11 numbers`)
        .nullable(),
      address: yup
        .string()
        .trim('* This field cannot contain only blankspaces')
        .required('Please enter store address')
        .matches(/[^\s*].*[^\s*]/g, '* This field cannot contain only blankspaces')
        .max(250, 'Max 250 characters')
        .nullable(),
      mapLink: yup
        .string()
        .trim('* This field cannot contain only blankspaces')
        .required('Please enter store google map link')
        .nullable(),
      city: yup
        .string()
        .trim('* This field cannot contain only blankspaces')
        .required('Please enter store city name')
        .matches(/^[a-zA-Z\s]+$/, 'Only characters are allowed')
        .max(150, 'Max 150 characters')
        .nullable(),
    }),
    onSubmit: handleStore,
  })

  // Get store by id
  const GetStore = useCallback(() => {
    const url = config.apiurl + `/store/${id}`
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        setDetails(res?.data?.data?.[0])
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    axios.get(url).then(onSuccess, onFailure)
  }, [id])
  useEffect(() => {
    GetStore()
  }, [GetStore])

  // set values on intial for update
  useEffect(() => {
    if (!_.isEmpty(details)) {
      formik.setFieldValue('mobileNo', details?.mobileNo)
      formik.setFieldValue('landline', details?.landlineNo)
      formik.setFieldValue('address', details?.address)
      formik.setFieldValue('mapLink', details?.mapLink)
      formik.setFieldValue('city', details?.city)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details])

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Edit Store</h6>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Mobile No
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="mobileNo"
                          id="mobileNo"
                          value={formik?.values?.mobileNo}
                          onChange={formik?.handleChange}
                        />
                        {formik?.errors?.mobileNo &&
                          formik?.touched?.mobileNo &&
                          formik?.errors?.mobileNo && (
                            <span className="text-danger text-gradient text-xs text-secondary">
                              {formik?.errors?.mobileNo}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Landline no
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="landline"
                          id="landline"
                          value={formik?.values?.landline}
                          onChange={formik?.handleChange}
                        />
                        {formik?.errors?.landline &&
                          formik?.touched?.landline &&
                          formik?.errors?.landline && (
                            <span className="text-danger text-gradient text-xs text-secondary">
                              {formik?.errors?.landline}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="col-md-6"></div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Address
                        </label>
                        <textarea
                          className="form-control"
                          type="text"
                          name="address"
                          id="address"
                          rows="5"
                          value={formik?.values?.address}
                          onChange={formik?.handleChange}
                        />
                        {formik?.errors?.address &&
                          formik?.touched?.address &&
                          formik?.errors?.address && (
                            <span className="text-danger text-gradient text-xs text-secondary">
                              {formik?.errors?.address}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Map Link
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="mapLink"
                          id="mapLink"
                          value={formik?.values?.mapLink}
                          onChange={formik?.handleChange}
                        />
                        {formik?.errors?.mapLink &&
                          formik?.touched?.mapLink &&
                          formik?.errors?.mapLink && (
                            <span className="text-danger text-gradient text-xs text-secondary">
                              {formik?.errors?.mapLink}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          City name
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="city"
                          id="city"
                          value={formik?.values?.city}
                          onChange={formik?.handleChange}
                        />
                        {formik?.errors?.city &&
                          formik?.touched?.city &&
                          formik?.errors?.city && (
                            <span className="text-danger text-gradient text-xs text-secondary">
                              {formik?.errors?.city}
                            </span>
                          )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="text-end">
                    <button
                      type="button"
                      onClick={formik?.handleSubmit}
                      className="btn btn-primary btn-sm ms-auto mt-5"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </>
  )
}

export default EditStore
